export enum UserAttributeIdentifierEnum {
  CCP = 'CCP',
  RiskTechData = 'RISKTECHDATA'
}
